import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonService } from '@core/services/common.service';
import { AgentSource } from '@shared/models/codebooks/agent-source';
import { UserRole } from '@shared/models/codebooks/user-role';
import { User } from '@shared/models/user';

@Component({
    selector: 'app-base-module',
    //templateUrl: './base-module.component.html',
    template: '',
    styleUrls: ['./base-module.component.scss'],
    standalone: false
})
export class BaseModuleComponent {
  public STATE_NAME: string;
  private STATE_TTL = 10;

  private _user: User;

  constructor(
    public commonService: CommonService
  ) {

    this.STATE_NAME = `${this.constructor.name}__state`;
  }

  public getLoggedUser(): User {
    this._user = this.commonService.getLoggedUser();
    return this._user;
  }

  public hasUserRole(RoleID: number): boolean {
    if (this._user.role == RoleID) {
      return true;
    }
    return false;
  }

  public hasAgentSource(agentSource: AgentSource): boolean {
    if (this._user.agentSource == agentSource) {
      return true;
    }
    return false;
  }

  public saveState(state: any, destinationState?: string): void {
    if (destinationState && destinationState.length > 0) {
      this.commonService.setToStorage(destinationState + '__state', state, this.STATE_TTL);
    } else {
      this.commonService.setToStorage(this.STATE_NAME, state, this.STATE_TTL);
    }
  }

  public loadState(): any {
    return this.commonService.getFromStorage(this.STATE_NAME);
  }
}
